import { Box, Card } from '@material-ui/core';

import {
  SidebarSection,
  useDisplayNames,
} from '@spotify/confidence-core-react';

import {
  AverageMeasurementQuery,
  MeasurementInput,
  RatioMeasurementQuery,
  toAverageSnippetConfig,
  toRatioSnippetConfig,
} from '../SimplifiedQuery';

type PreviewSectionProps = {
  value: MeasurementInput;
};

export const PreviewSection = ({ value }: PreviewSectionProps) => {
  const { displayNames } = useDisplayNames();

  const averageConfig = toAverageSnippetConfig(value);
  const ratioConfig = toRatioSnippetConfig(value);

  return (
    <SidebarSection.Root>
      <SidebarSection.Header>
        <SidebarSection.Title>Preview</SidebarSection.Title>
      </SidebarSection.Header>
      <SidebarSection.Content>
        <Card variant="outlined">
          <Box padding={4}>
            {averageConfig && (
              <AverageMeasurementQuery
                {...averageConfig}
                entity={displayNames.get(value.entity ?? '')}
                factTable={displayNames.get(value.factTable ?? '')}
              />
            )}
            {ratioConfig && (
              <RatioMeasurementQuery
                {...ratioConfig}
                entity={displayNames.get(value.entity ?? '')}
                factTable={displayNames.get(value.factTable ?? '')}
              />
            )}
          </Box>
        </Card>
      </SidebarSection.Content>
    </SidebarSection.Root>
  );
};
